module.exports = __webpack_public_path__ + "static/media/second.665d9276.png";